import { useIntl } from 'react-intl';
import { Row, Col } from 'src/componentes/grid';

import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import PanelCollapse from 'src/componentes/panel-collapse';
import PeriodoData from 'src/paginas/data/periodo-data.jsx';
import AreaLookup from 'src/lookups/item-organizacao';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import TipoIdentificacaoFormularioGlobalLookup from 'src/lookups/TipoIdentificacaoFormularioGlobalLookup';
import StatusPesquisaClimaLookup from 'src/lookups/StatusPesquisaClimaLookup';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';
import { TIPO_IDENTIFICACAO_FORMULARIO_GLOBAL } from 'src/utils/constants';

const Search = ({ model }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const handleChangeFiltro = (field, value) => {
    model.getModel(field).requestChange(value);
  };

  return (
    <PanelCollapse
      ehAccordionDrawer
      header={capitalizeFirstLetter(
        intl.formatMessage({ id: 'label.informacoesBasicas' })
      )}
      hideShadow
      open
    >
      <Row>
        <Col md={12}>
          <Input model={model.getModel('idIntegracao')} />
        </Col>
        <Col md={12}>
          <Input model={model.getModel('nome')} />
        </Col>
        <Col md={12}>
          <AreaLookup
            clearable
            compactMulti
            multi
            model={{
              label: capitalizeFirstLetter(resources.areas),
              value: model.getModel('areas').value,
              requestChange: (value) => {
                model.getModel('areas').requestChange(value);

                if (!value || value.length === 0) {
                  model.getModel('areasSubordinadas').requestChange(false);
                }
              },
            }}
          />
        </Col>
        <Col md={12}>
          <Checkbox
            className="mb-3"
            disabled={!model.getModel('areas').value?.length}
            model={{
              label: intl.formatMessage(
                { id: 'label.considerarAreasSubordinadas' },
                { areas: resources.areas }
              ),
              value: model.getModel('areasSubordinadas').value,
              requestChange: model.getModel('areasSubordinadas').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <ColaboradorEGrupoSimplificadoLookup
            abrirEmDrawer
            exibirGrupos={false}
            labelComoTitulo
            compactMulti
            multi
            clearable
            model={{
              label: capitalizeFirstLetter(resources.responsaveis),
              value: model.getModel('responsaveis').value,
              requestChange: model.getModel('responsaveis').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <Input type="textarea" rows={3} model={model.getModel('descricao')} />
        </Col>
        <Col md={12}>
          <PeriodoData
            clearable
            isDrawerFilter
            data={{ idsIgnorados: [7, 8, 9, 10] }}
            tipoFiltroData={model.getModel('tipoPeriodoDataInicio').value}
            dataInicio={model.getModel('dataInicioDe').value}
            dataTermino={model.getModel('dataInicioAte').value}
            tipoFiltroDataField="tipoPeriodoDataInicio"
            dataInicioField="dataInicioDe"
            dataTerminoField="dataInicioAte"
            onChange={handleChangeFiltro}
            customLabelTipoPeriodo={capitalizeFirstLetter(
              intl.formatMessage({ id: 'labelPeriodoDataInicio' })
            )}
            customLabelDataInicio={capitalizeFirstLetter(
              intl.formatMessage({ id: 'deDataInicial' })
            )}
            customLabelDataTermino={capitalizeFirstLetter(
              intl.formatMessage({ id: 'ateDataFinal' })
            )}
          />
        </Col>
        <Col md={12}>
          <PeriodoData
            clearable
            isDrawerFilter
            data={{ idsIgnorados: [7, 8, 9, 10] }}
            tipoFiltroData={model.getModel('tipoPeriodoDataTermino').value}
            dataInicio={model.getModel('dataTerminoDe').value}
            dataTermino={model.getModel('dataTerminoAte').value}
            tipoFiltroDataField="tipoPeriodoDataTermino"
            dataInicioField="dataTerminoDe"
            dataTerminoField="dataTerminoAte"
            onChange={handleChangeFiltro}
            customLabelTipoPeriodo={capitalizeFirstLetter(
              intl.formatMessage({ id: 'labelPeriodoDataTermino' })
            )}
            customLabelDataInicio={capitalizeFirstLetter(
              intl.formatMessage({ id: 'deDataInicial' })
            )}
            customLabelDataTermino={capitalizeFirstLetter(
              intl.formatMessage({ id: 'ateDataFinal' })
            )}
          />
        </Col>
        <Col md={12}>
          <TipoIdentificacaoFormularioGlobalLookup
            clearable
            data={{
              idsIgnorar: [TIPO_IDENTIFICACAO_FORMULARIO_GLOBAL.ANONIMA],
            }}
            model={{
              label: capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelTipoPesquisa' })
              ),
              value: model.getModel('tipoIdentificacao').value,
              requestChange: model.getModel('tipoIdentificacao').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <StatusPesquisaClimaLookup
            compactMulti
            multi
            clearable
            model={{
              label: capitalizeFirstLetter(
                intl.formatMessage({ id: 'status' })
              ),
              value: model.getModel('status').value,
              requestChange: model.getModel('status').requestChange,
            }}
          />
        </Col>
      </Row>
    </PanelCollapse>
  );
};

export default Search;
